<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            dialogWidth="80%"
            :tableHeight="screenHeight - 170"
            :addButton="{ enabled: false, label: '创建手术', permission: 'default' }"
            :updateButton="{ enabled: false }"
            :columnConfig="columnConfig"
            @loadingOverruleView="loadingOverruleView"
            :selection="true"
            @selectionChange="checkedRow"
            @loadingOneView="loadingOneView"
        >
            <slot slot="filter">
                <el-col :span="8">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="8" :lg="5" :xl="5">
                    <item-input type="multiselect" v-model="surgery_status" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="btnprint()">打印<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="loadingNewSurgery()" title="">创建手术<i class="el-icon--right"></i></el-button>
            </slot>
            <span slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </span>
        </crud-facecade>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
        <EditSurgeryNew :visible.sync="saveas.dialogFormVisible" :footerVisible="saveas.showSaveBtn" :title="saveas.title" :data="saveas.data" @save-success="saveAsSuccess"></EditSurgeryNew>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditSurgeryNew from './EditSurgeryNew.vue'
export default {
    name: `ApplySurgeryNew`,
    props: {},
    components: { EditSurgeryNew },
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        return {
            title: `手术申请`,
            rejectReasons: [],
            checkedRows: [],
            surgeryinfopush: this.$root.SurgeryInfoPush,
            url: {
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.ReloadListData()
                },
                post: data => {
                    return new Promise(resolve => {
                        let obj = {
                            sequence: data.sequence,
                            apply_time: data.apply_time,
                            plan_time: data.plan_time,
                            cost_time: data.cost_time,
                            infectious: data.infectious && data.infectious.join(`,`),
                            is_fasting: data.is_fasting,
                            is_day_surgery: data.is_day_surgery,
                            is_endoscopy: data.is_endoscopy,
                            remark: data.remark,
                            enum_asa: data.enum_asa,
                            enum_surgery_scale: data.enum_surgery_scale,
                            enum_surgery_type: data.enum_surgery_type,
                            dic_section_id: data.dic_section_id,
                            dic_inpatient_section_id: data.dic_inpatient_section_id,
                            dic_operating_room_id: data.dic_operating_room_id,
                            dic_operating_room: data.dic_operating_room,
                            dic_operating_ward_id: data.dic_operating_ward_id,
                            enum_isolation_status: data.enum_isolation_status,
                            enum_cut_level: data.enum_cut_level,
                            iconValue: `el-icon-star-on`,
                            visit_info: {
                                age: data.age,
                                height: data.height,
                                weight: data.weight,
                                bed_no: data.bed_no,
                                visit_no: data.visit_no,
                                outpatient_no: data.outpatient_no,
                                visit_time: data.visit_time,
                                phone: data.phone,
                                address: data.address,
                                enum_visit_type: data.enum_visit_type,
                                enum_pay_type: data.enum_pay_type,
                                name: data.name,
                                birthday: data.birthday,
                                card_type: data.card_type,
                                card_no: data.card_no,
                                insurance_no: data.insurance_no,
                                enum_blood_type: data.enum_blood_type,
                                enum_rh_blood_type: data.enum_rh_blood_type,
                                enum_sex: data.enum_sex
                            },
                            // plan_anaes_methods: data.plan_anaes_methods,
                            plan_diseases: data.plan_diseases.map(d => d.value),
                            plan_surgeon: data.plan_surgeon,
                            plan_surgeon_assistants: data.plan_surgeon_assistants,
                            plan_anes_doctor: data.plan_anes_doctor,
                            plan_anes_assistants: data.plan_anes_assistants,
                            plan_circuit_nurse: data.plan_circuit_nurse,
                            plan_equipment_nurse: data.plan_equipment_nurse,
                            surgery_items: []
                        }
                        // 新增的时候把动态列字段放到obj.extra_datas对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                        let req = this.myaxios.post(`/api/Preoperative/Apply/NewPost`, obj)
                        let that = this
                        req.then(res => {
                            that.$refs[`surgery-list`].ReloadListData()
                            resolve(res)
                        }).catch((e) => console.log(e))
                    })
                },
                getOne: row => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/Preoperative/Apply/NewGet/${row.id}`)
                        req.then(data => {
                            let obj = {
                                id: data.id,
                                sequence: data.sequence,
                                plan_time: data.plan_time,
                                apply_time: data.apply_time,
                                cost_time: data.cost_time,
                                infectious: data.infectious && data.infectious.split(`,`),
                                is_fasting: data.is_fasting,
                                is_day_surgery: data.is_day_surgery,
                                is_endoscopy: data.is_endoscopy,
                                his_remark: data.his_remark,
                                remark: data.remark,
                                enum_asa: data.enum_asa,
                                enum_surgery_scale: data.enum_surgery_scale,
                                enum_surgery_type: data.enum_surgery_type,
                                dic_section_id: data.dic_section_id,
                                dic_inpatient_section_id: data.dic_inpatient_section_id,
                                dic_operating_room_id: data.dic_operating_room_id,
                                dic_operating_ward_id: data.dic_operating_ward_id,
                                enum_isolation_status: data.enum_isolation_status,
                                enum_cut_level: data.enum_cut_level,
                                age: data.visit_info.age,
                                height: data.visit_info.height,
                                weight: data.visit_info.weight,
                                bed_no: data.visit_info.bed_no,
                                visit_no: data.visit_info.visit_no,
                                outpatient_no: data.visit_info.outpatient_no,
                                visit_time: data.visit_info.visit_time,
                                visit_type: data.visit_info.enum_visit_type,
                                phone: data.visit_info.phone,
                                address: data.visit_info.address,
                                enum_visit_type: data.visit_info.enum_visit_type,
                                enum_pay_type: data.visit_info.enum_pay_type,
                                name: data.visit_info.name,
                                birthday: data.visit_info.birthday,
                                card_type: data.visit_info.card_type,
                                card_no: data.visit_info.card_no,
                                insurance_no: data.visit_info.insurance_no,
                                enum_blood_type: data.visit_info.enum_blood_type,
                                enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                                enum_sex: data.visit_info.enum_sex,
                                plan_anaes_methods: data.plan_anaes_methods.map(d => d.value),
                                plan_diseases: data.plan_diseases,
                                plan_surgeries: data.plan_surgeries,
                                surgery_items: data.surgery_items,
                                plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                                plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                                plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value,
                                plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                                plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                                plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value)
                            }
                            // getone的时候把动态列字段放到obj对象里面
                            this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, obj, data)
                            resolve(obj)
                        }).catch(e => reject(e))
                    })
                },
                put: data => {
                    return new Promise((resolve, reject) => {
                        var obj = {
                            id: data.id,
                            sequence: data.sequence,
                            plan_time: data.plan_time,
                            apply_time: data.apply_time,
                            cost_time: data.cost_time,
                            infectious: data.infectious && data.infectious.join(`,`),
                            is_fasting: data.is_fasting,
                            is_day_surgery: data.is_day_surgery,
                            is_endoscopy: data.is_endoscopy,
                            remark: data.remark,
                            enum_asa: data.enum_asa || `-1`,
                            enum_surgery_scale: data.enum_surgery_scale || `-1`,
                            enum_surgery_type: data.enum_surgery_type || `-1`,
                            dic_section_id: data.dic_section_id || `-1`,
                            dic_inpatient_section_id: data.dic_inpatient_section_id || `-1`,
                            dic_operating_room_id: data.dic_operating_room_id || `-1`,
                            dic_operating_ward_id: data.dic_operating_ward_id || `-1`,
                            enum_isolation_status: data.enum_isolation_status || `-1`,
                            enum_cut_level: data.enum_cut_level || `-1`,
                            visit_info: {
                                age: data.age,
                                height: data.height,
                                weight: data.weight,
                                bed_no: data.bed_no,
                                visit_no: data.visit_no,
                                outpatient_no: data.outpatient_no,
                                visit_time: data.visit_time,
                                phone: data.phone,
                                address: data.address,
                                enum_visit_type: data.enum_visit_type || `-1`,
                                enum_pay_type: data.enum_pay_type || `-1`,
                                name: data.name,
                                birthday: data.birthday,
                                card_type: data.card_type,
                                card_no: data.card_no,
                                insurance_no: data.insurance_no,
                                enum_blood_type: data.enum_blood_type || `-1`,
                                enum_rh_blood_type: data.enum_rh_blood_type || `-1`,
                                enum_sex: data.enum_sex === `` ? `-1` : data.enum_sex
                            },
                            // plan_anaes_methods: data.plan_anaes_methods,
                            plan_diseases: data.plan_diseases.map(d => d.value),
                            surgery_items: [],
                            plan_surgeon: data.plan_surgeon,
                            plan_surgeon_assistants: data.plan_surgeon_assistants,
                            plan_anes_doctor: data.plan_anes_doctor || `-1`,
                            plan_anes_assistants: data.plan_anes_assistants,
                            plan_circuit_nurse: data.plan_circuit_nurse,
                            plan_equipment_nurse: data.plan_equipment_nurse
                        }
                        // 修改的时候把动态列字段放到obj.extra_datas对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Put`, obj)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                }
            },
            buttons: [
            ],
            rdate: [
                this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment()
                    .add(6, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            relation: {
                title: ``,
                visible: false,
                item: {}
            },
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                data: {},
                surgeryId: 0,
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ],
                visit_info: {}
            },
            saveas: {
                dialogFormVisible: false,
                data: {},
                showSaveBtn: true
            },
            inpatient_section: [],
            sysusers: [],
            columnConfig: true,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            id: undefined,
            surgery_status: [10], // 20
            dic_room_id: undefined,
            surgery_items: []
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadingInpatientSectionData()
    },
    mounted() {
        this.loadRejectResons()
    },
    computed: {
        ...mapGetters([
            `screenHeight`,
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `active_ward`,
            `permissions`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (!this.issetoperatingward && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        filterInpatientSection() {
            let r = this.inpatient_section
            return r && r.map(d => {
                let r = { ...d }
                r.code = ``
                return r
            }) || []
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`
                },
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    width: `80`,
                    isListable: true,
                    options: this.sys_enums.VisitType || []
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `is_local_anes_val`,
                    label: `麻醉类型`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: false,
                    sortable: false,
                    options: `enum_bool`
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `状态`,
                    width: `80`,
                    isListable: true,
                    searchable: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `申请台次`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery_new.visit_no`),
                    isListable: true,
                    searchable: false,
                    sortable: false,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isListable: true,
                    searchable: false,
                    sortable: false,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true,
                    searchable: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `80`,
                    isListable: true,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    isListable: true,
                    searchable: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: true,
                    searchable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anaes_methods`,
                    label: `计划麻醉方式`,
                    width: `140`,
                    isListable: true,
                    options: `/api/AcisSystem/AnaesthesiaMethod/Search`
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true,
                    searchable: true,
                    sortable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`apply_surgery_new.surgeon`),
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    width: `120`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    fixed: `right`,
                    label: `操作`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false,
                    sortable: false,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.enum_surgery_status !== -1) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `驳回`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `loadingOverruleView`,
                                    permission: `surgery_list:reject`
                                },
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadingOneView`,
                                    permission: `default`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadingOneView`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }
            // 批处理是否可编辑那些属性
            list = this.$surgeryInfoExtraParamUtil.SetOtherSettingColumn(list, this.otherSettingColumn)
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            return list
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    methods: {
        checkedRow({ row }) {
            this.checkedRows = row
        },
        btnprint() {
            let docId = this.$root.DOCUMENT[`SSSQ001`]
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                // 批量打印手术通知单
                let printlist = this.checkedRows
                if (printlist.length) {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: docId,
                                id1: `99999`,
                                objId: printlist.map(d => d.id).toString()
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                } else {
                    this.$message.warning(`请选择需要打印的手术申请`)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        loadDocList(operatingWardId, q) {
            let r = {
                operatingWardId: operatingWardId || (this.active_ward && this.active_ward.value.split(`_`)[1]),
                workerRole: 1,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/Search`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        loadNurseList(operatingWardId, q) {
            let r = {
                operatingWardId: operatingWardId || (this.active_ward && this.active_ward.value.split(`_`)[1]),
                workerRole: 2,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/Search`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        loadingOverruleView({ index, row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将驳回“${row.patient_name}”“${row.visit_no}”的手术申请`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.loadDocList()
                    this.loadNurseList()
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    this.overrule.dialogFormVisible = true
                    this.overrule.surgeryId = row.id
                    this.overrule.visit_info = {
                        id: row.visit_id,
                        visit_no: row.visit_no,
                        outpatient_no: row.outpatient_no,
                        enum_visit_type: row.visit_type,
                        his_id: row.his_id,
                        name: row.patient_name
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadingOneView({ index, row }) {
            let req = this.myaxios.get(`/api/Preoperative/Apply/NewGet/${row.id}`)
            req.then(data => {
                let obj = {
                    id: data.id,
                    is_archived: data.is_archived, // 手术对应的麻醉单是否已归档
                    sequence: data.sequence,
                    plan_time: data.plan_time,
                    apply_time: data.apply_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.split(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    his_remark: data.his_remark,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    dic_section_id: data.dic_section_id,
                    sectionobj: data.sectionobj,
                    inpatientobj: data.inpatientobj,
                    dic_inpatient_section_id: data.dic_inpatient_section_id,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    age: data.visit_info.age,
                    height: data.visit_info.height,
                    weight: data.visit_info.weight,
                    bed_no: data.visit_info.bed_no,
                    visit_no: data.visit_info.visit_no,
                    outpatient_no: data.visit_info.outpatient_no,
                    visit_time: data.visit_info.visit_time,
                    visit_type: data.visit_info.enum_visit_type,
                    phone: data.visit_info.phone,
                    address: data.visit_info.address,
                    enum_visit_type: data.visit_info.enum_visit_type,
                    enum_pay_type: data.visit_info.enum_pay_type,
                    name: data.visit_info.name,
                    birthday: data.visit_info.birthday,
                    card_type: data.visit_info.card_type,
                    card_no: data.visit_info.card_no,
                    insurance_no: data.visit_info.insurance_no,
                    enum_blood_type: data.visit_info.enum_blood_type,
                    enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                    enum_sex: data.visit_info.enum_sex,
                    plan_diseases: data.plan_diseases,
                    plan_surgeries: data.plan_surgeries,
                    surgery_items: data.surgery_items,
                    plan_surgeon: data.plan_surgeon,
                    plan_surgeon_assistants: data.plan_surgeon_assistants,
                    plan_anes_doctor: data.plan_anes_doctor,
                    plan_anes_assistants: data.plan_anes_assistants,
                    plan_surgery_guidance: data.plan_surgery_guidance,
                    plan_anes_guidance: data.plan_anes_guidance,
                    plan_circuit_nurse: data.plan_circuit_nurse,
                    plan_equipment_nurse: data.plan_equipment_nurse
                }
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, obj, data)
                this.saveas.title = `编辑手术`
                this.saveas.data = obj
                this.saveas.dialogFormVisible = true
                // 手术麻醉单归档后不能在保存
                let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
                if (caneditarchived) {
                    this.saveas.showSaveBtn = true
                } else {
                    this.saveas.showSaveBtn = !obj.is_archived
                }
            }).catch(e => console.log(e))
        },
        saveOverrule(row) {
            let that = this
            let requestData = {
                id: this.overrule.surgeryId,
                visit_info: this.overrule.visit_info,
                reject_reason: row.reject_reason
            }
            let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
            req.then(data => {
                // 调用手术回写
                let pushModel = {
                    surgeryId: this.overrule.surgeryId,
                    surgeryInfoSendType: 1
                }
                var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                reps.then(data => {
                    that.overrule.dialogFormVisible = false
                    that.$refs[`surgery-list`].ReloadListData()
                    console.log(data)
                })
            }).catch(e => {})
        },
        ReloadListData() {
            // added by xiaorui ACIS-22650,更改日期触发更新列表
            let that = this
            that.surgery_items = []
            return new Promise(resolve => {
                let req = that.myaxios.post(`/api/Preoperative/Apply/GetSurgeryWithStatus?begin=${this.rdate[0]}&end=${this.rdate[1]}`, that.surgery_status)
                req.then(data => {
                    let r = data
                    if (that.dic_operating_ward_id) {
                        r = _.filter(data, d => {
                            let result = true
                            if (that.dic_operating_ward_id) {
                                result = d.dic_operating_ward_id == that.dic_operating_ward_id
                            }

                            if (result && that.dic_room_id) {
                                result = d.dic_operating_room_id == that.dic_room_id
                            }
                            return result
                        })
                    }
                    r = _.map(r, d => {
                        d.class_name = `surgery_status_${d.enum_surgery_status} surgery_type_${d.enum_surgery_type}`

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)

                        return d
                    })
                    resolve(r)
                }).catch(e => {
                    resolve([])
                })
            })
            // that.$refs["surgery-list"].ReloadListData()  /api/AcisSystem/InpatientSection/Post
        },
        loadingInpatientSectionData() {
            let req = this.myaxios.get(`/api/AcisSystem/InpatientSection/Search`)
            req.then(data => {
                // console.log(...data)
                this.inpatient_section = data
            })
        },
        loadRejectResons() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ApplyRejectResons`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.rejectReasons = data.value.trim().split(`,`).map(x => {
                            return {
                                label: x,
                                value: x
                            }
                        })
                    } else {
                        this.rejectReasons = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadingNewSurgery() {
            let data = {
                surgery_items: [{
                    is_empty: true
                }]
            }
            this.saveas.title = `新增手术`
            this.saveas.data = data
            this.saveas.showSaveBtn = true
            this.saveas.dialogFormVisible = true
        },
        saveAsSuccess() {
            this.$refs[`surgery-list`].ReloadListData()
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            sessionStorage.setItem(`memory_operating_ward_id`, newVlaue)
            this.$refs[`surgery-list`].ReloadListData()
            this.loadDocList()
            this.loadNurseList()
        },
        surgery_status: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_room_id: function() {
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style lang="less">
.title1 p {
    background: lightgray;
    font-size: 20px;
}
.title2 p {
    background: lightgray;
    font-size: 20px;
}
.surgery_status_20 td {
    color: var(--primary-color, #009688);
}
.surgery_type_1 td {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/ApplySurgeryNew.vue